import React, { useState, useEffect, useContext } from 'react';

import UploadPDF from '../../inputs/UploadPDF'
import ButtonBack from '../../../components/button/ButtonBack'
import ButtonNext from '../../../components/button/ButtonWhite'

import { ReactComponent as BACK } from '../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg';
import { ReactComponent as NEXT } from '../../../assets/IconsColurs/IconsGeneral/chevronRight.svg';

import { UtilContext } from "../../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../../language/language";

const Step6 = ({
    documentsStep4Error,
    onClick,
    ProgressStep,
    onClickBack,
    errorMesagge = "",
    setDocuments1,
    setDocuments2,
    setDocuments3,
    setDocuments4,
    setDocuments5,
    setdocumentsStep4,
    documentsStep4,
    documents1,
    documents2,
    documents3,
    documents4,
    documents5,
    documents1Error,
    documents2Error,
    documents3Error,
    documents4Error,
    documents5Error,
    documents6Error,
    loading,
    LoadingLayouts,
    LoadingBack
}) => {
    const { language } = useContext(UtilContext); // Usa el contexto de Auth
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;


    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        if (
            !LoadingLayouts

        ) {
            setIsReady(true)
        }
    }, [
        LoadingLayouts
    ]);
    if (!isReady) {
        return <div className="flex md:flex-row flex-wrap p-4 w-full" >
            <div className="w-full" >
                <div style={{ height: "50vh", }} className='flex items-center justify-center'>
                    <div className="h-20  w-20 flex">
                        <div className="spinner-border-white-full animate-spin w-14 h-14 border-4 border-white border-t-transparent rounded-full"></div>

                    </div>
                </div>
            </div>
        </div>

    }
    /* falta validacion upload 6 */
    return (
        <div className="w-full h-fit pb-16"  >
            <div className='gap-2 flex flex-col ' >
                <p className=" text-2xl mt-8 " style={{ fontFamily: "brico" }} >
                    {t.steps6.title}
                </p>
                {language !== 'es' && <p className='text-[#E4E4E4]' >{GLOBAL_LANGUAGE[language].steps6.description}</p>}
            </div>

            <div className=' mt-12 ' >
                <p className='mb-1 text-[#B7B7B9]' >{t.documents.good_conduct_certificate}</p>
                <UploadPDF setUploadedFile={setDocuments1} uploadedFile={documents1} error={documents1Error} />
            </div>

            <div className='w-full bg-[#5E5E63] h-[1px] my-4 '></div>
            <div>
                <p className='mb-1 text-[#B7B7B9] text-[16px]' >{t.documents.proof_of_address}</p>
                <UploadPDF setUploadedFile={setDocuments2} uploadedFile={documents2} error={documents2Error} />
            </div>


            {/*  <div>
                <p className='text-[#B7B7B9]'>
                    {t.documents.shareholder_certification}

                </p>
                <UploadPDF setUploadedFile={setdocumentsStep4} uploadedFile={documentsStep4} error={documentsStep4Error} />

                <div className='w-full bg-[#5E5E63] h-[1px] mt-6'></div>
            </div>

            <div>
                <p className='mb-1 text-[#B7B7B9] text-[16px]' >{t.documents.document_ID_shareholder}</p>
                <UploadPDF setUploadedFile={setDocuments3} uploadedFile={documents3} error={documents3Error} />
            </div> */}


            <div className='w-full bg-[#5E5E63] h-[1px] my-4 '></div>
            <div>
                <p className='mb-1 text-[#B7B7B9] text-[16px]' >{t.documents.doccounter_background_check}</p>
                <UploadPDF setUploadedFile={setDocuments4} uploadedFile={documents4} error={documents4Error} />
            </div>

            <div className='w-full bg-[#5E5E63] h-[1px] my-4 '></div>
            <div>
                <p className='mb-1 text-[#B7B7B9] text-[16px]' >{t.documents.professional_accountant_license}</p>
                <UploadPDF setUploadedFile={setDocuments5} uploadedFile={documents5} error={documents5Error} />
            </div>

            {errorMesagge && (
                <div className="w-full flex flex-col mt-4 mb-4">
                    <p className="text-[#FF928B] text-[16px]">{t.steps6.error_label}</p>
                </div>
            )}

            <div className='flex flex-col-reverse md:flex-row justify-between w-full gap-4 mt-8' >
                <ButtonBack
                    label={t.steps6.label_button_back}
                    Icon={BACK}
                    onClick={onClickBack}
                    loading={LoadingBack}
                    className="w-full md:w-auto"
                />
                <ButtonNext
                    label={t.steps6.label_button_next}
                    Icon={NEXT}
                    onClick={onClick}
                    loading={loading}
                    className="w-full md:w-auto"
                />
            </div>
        </div >

    );
};

export default Step6;

